var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V2.14286C20 0.959375 19.0406 0 17.8571 0ZM7.95165 10.2725C3.90308 7.33424 3.94433 7.32683 2.85714 6.48067V5.35714C2.85714 4.7654 3.33683 4.28571 3.92857 4.28571H16.0714C16.6632 4.28571 17.1429 4.7654 17.1429 5.35714V6.48067C16.0549 7.3275 16.0967 7.33442 12.0483 10.2725C11.5796 10.6143 10.6469 11.4386 10 11.4285C9.35254 11.4383 8.42112 10.6148 7.95165 10.2725ZM17.1429 8.29353V14.6429C17.1429 15.2346 16.6632 15.7143 16.0714 15.7143H3.92857C3.33683 15.7143 2.85714 15.2346 2.85714 14.6429V8.29353C3.48027 8.7754 4.34504 9.42013 7.11174 11.4281C7.74397 11.8897 8.80705 12.8631 9.99987 12.8571C11.2002 12.8631 12.2783 11.8731 12.8892 11.4274C15.6551 9.42004 16.5197 8.77536 17.1429 8.29353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c35beebf6efbb6b3f33e122e6160bfee.svg";
export { ForwardRef as ReactComponent };